export default function Variation() {
  return (
    <div>
      In addition to the right to vary the Fees (as described above),&nbsp;
      the Information Service Provider may amend these terms from time&nbsp;
      to time. The Customer must look at the beginning of these terms&nbsp;
      to see when they were last updated and which terms were changed.&nbsp;
      Every time that Services are ordered, the terms in force at the&nbsp;
      time of that order will, subject to Clause below, apply to the&nbsp;
      Contract for Services relating to that order.
      <br />
      <br />
      The Information Service Provider may revise these terms as they&nbsp;
      apply to an order from time to time as a result of but not limited to:
      <br />
      <br />
      <ul>
        <li>changes in relevant laws and regulatory requirements; and/ or</li>
        <li>
          changes in terms of service by third parties on which the&nbsp;
          Information Service Provider is reliant in order to provide its’ own services
        </li>
      </ul>
      <br />
      <br />
      If the Information Service Provider has to revise these terms&bsp;
      under Clause above, the Information Service Provider will&nbsp;
      endeavour to provide the Customer with not less than 7 days;&nbsp;
      notice of such change via the site but cannot guarantee it&nbsp;
      will be able to do so in the event that such a revision occurs&nbsp;
      as a result of actions taken by a third party and the Customer&nbsp;
      may choose to exercise its right to terminate, as described above.
    </div>
  );
}
